import { MatChipsModule } from '@angular/material/chips';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NewHomepageRoutingModule } from './new-homepage-routing.module';
import { NewHomepageLandingComponent } from './new-homepage-landing/new-homepage-landing.component';
import { NewHomepageHeaderComponent } from './new-homepage-header/new-homepage-header.component';
import { NewHomepageFooterComponent } from './new-homepage-footer/new-homepage-footer.component';
import { NewHomepageComponent } from './new-homepage.component';
import { WelcomeHomepageModalComponent } from './welcome-homepage-modal/welcome-homepage-modal.component';
import { NgbCarousel, NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [
    NewHomepageLandingComponent,
    NewHomepageHeaderComponent,
    NewHomepageFooterComponent,
    NewHomepageComponent,
    WelcomeHomepageModalComponent
  ],
  imports: [
    CommonModule,
    NewHomepageRoutingModule,
    NgbCarouselModule,
    MatChipsModule
  ],
  exports: [
    NewHomepageLandingComponent,
    NewHomepageHeaderComponent,
    NewHomepageFooterComponent,
    NewHomepageComponent
  ],
  entryComponents: [
    WelcomeHomepageModalComponent
  ]
})
export class NewHomepageModule { }
